export const META_TAG_TITLE = '후루츠패밀리 - 빈티지, 세컨핸드 패션 중고거래 앱';
